import React from 'react';
import './PriceDisplay.css';

const PriceDisplay = ({ originalPrice, finalPrice, currency = '$', period }) => {
  if (!finalPrice && finalPrice !== 0) {
    return (
      <div className="price-display">
        <div className="final-price">Precio no disponible</div>
      </div>
    );
  }

  return (
    <div className="price-display">
      {originalPrice && (
        <div className="original-price">
          {currency} {originalPrice.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
        </div>
      )}
      <div className="final-price">
        {currency} {finalPrice.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
      </div>
      {period && <div className="price-period">{period}</div>}
    </div>
  );
};

export default PriceDisplay;
